import ProduitI18n from './Produit.i18n.js';
import {
  mapGetters,
  mapActions,
  mapMutations,
} from 'vuex'
export default {

  components: {},

  computed: {
    ...mapGetters(['familles', 'articleLoading', 'articles', 'article', 'cart']),
    prixCalcule() {
      return this.article.prix * (1 - this.article.reduction / 100).toFixed(2)
    },
    canAddInCart() {
      let canAdd = true
      if (this.isInCart(this.article)) {
        this.cart.forEach(aProduct => {
          if (aProduct.id === this.article.id) {
            if (parseInt(aProduct.quantite) + 1 > parseInt(this.article.quantite_stock)) {
              canAdd = false
            }
          }
        })
      }
      return canAdd
    },
  },

  props: {},

  data() {
    return {
      currentPhotoLink: '',
      notifAjout: false,
      tabQuantite: []
    };
  },

  watch: {},

  methods: {
    ...mapMutations(['addToCart']),
    ...mapActions(['getArticlesActifs', 'getArticle']),
    /**
     * Function to change the current photo.
     * @param {*} pPhotoLink 
     */
    changePhoto(pPhotoLink) {
      this.currentPhotoLink = pPhotoLink
    },
    /**
     * Function to know if the product is already in the cart.
     * @param {*} pProd 
     */
    isInCart(pProd) {
      let isInCart = false
      this.cart.forEach(aProduct => {
        if (aProduct.id === pProd.id) {
          isInCart = true
        }
      })
      return isInCart
    },



    /**
     * Ajout au panier.
     */
    addProductToCart(pProduct) {
      pProduct.totalProductPrice = pProduct.price
      this.addToCart(pProduct)
      this.notifAjout = true
      setTimeout(() => {
        this.notifAjout = false
      }, 5000);
    },
    getPhotoLink(pPhotoLink) {
      return pPhotoLink + '?cacheKey=' + Date.now()
    }
  },

  filters: {
    currency: (value) => {
      const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    }
  },

  mounted() {
    const info = {
      catId: this.$route.params.catId,
      famId: this.$route.params.famId,
      prodId: this.$route.params.prodId
    }
    this.getArticle(info).then(res => {
      this.currentPhotoLink = this.article.photoLink1
    }).catch(err => {
      console.log(err)
    })

  },

  i18n: ProduitI18n,

};